export default "__VITE_ASSET__BgxM3umy__"